/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Artcraft_QInputs */

const en_wc_faq_artcraft_q = /** @type {(inputs: Wc_Faq_Artcraft_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is ArtCraft WordCraft?`)
};

/**
* | output |
* | --- |
* | "What is ArtCraft WordCraft?" |
*
* @param {Wc_Faq_Artcraft_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_artcraft_q = /** @type {((inputs?: Wc_Faq_Artcraft_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Artcraft_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_artcraft_q(inputs)
});
export { wc_faq_artcraft_q as "wc.faq.artcraft.q" }